import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ContactForm from "../components/ContactForm";
import { Hero, Marquee, About, Problem, Solution, HowItWorks } from "../components/Sections1";
import { Products, Sectors, Features, Why, Gallery, CaseStudies, FAQ, FinalCTA } from "../components/Sections2";
import { scrollToId } from "../lenis";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Smart Locker per Condomini e Aziende | BOXLY";
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // wait for Lenis + layout to settle
      const t = setTimeout(() => scrollToId(id), 400);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <About />
      <Problem />
      <Solution />
      <HowItWorks />
      <Products />
      <Sectors />
      <Features />
      <Why />
      <Gallery />
      <CaseStudies />
      <FAQ />
      <FinalCTA />
      <ContactForm />
    </main>
  );
}
